import {
    Form, FormButton, FormButtonContainer, FormItem, FormSubmitHandler, useAlerts, useForm
} from "@sis/react-library";
import { ExampleDto } from './FormSamplesCustomControlPage';
import { FormSamplesRockPaperScissorsInput } from "./FormSamplesRockPaperScissorsInput";

/////////////////////////////////////////////////////////////////////////////////////////////
// Interface for the form (see basic usage example for more information).
/////////////////////////////////////////////////////////////////////////////////////////////
// allow no members for shorter name to be more readable below
// eslint-disable-next-line
interface T extends ExampleDto { }

interface FormSamplesCustomControlFormProps {
    onSubmit: FormSubmitHandler<ExampleDto>;
    submitting: boolean;
}

export const FormSamplesCustomControlForm = ({
    onSubmit, submitting
}: FormSamplesCustomControlFormProps) => {

    const formName = 'FormCustomControl';

    const { resetForm } = useForm<T>(formName);
    const { confirm } = useAlerts();

    const handleCancel = () => {
        confirm('Cancel', 'Are you sure you want to cancel and loose your changes?',
            () => { resetForm() },
            "Yes", "No"
        );
    }

    return (
        <Form<T>
            name={formName}
            onSubmit={onSubmit}
            submitting={submitting}
            beforeLeaveText='You have made changes, are you sure you want to leave ?'
        >
            <FormItem<T>
                formField="playerChoice"
                label="Players Choice"                
                // You can create your own custom control, 
                // The control FormSamplesRockPaperScissorsInput is defined in this samples project and not from the library.
                element={<FormSamplesRockPaperScissorsInput />}
            />
            <FormButtonContainer>
                <FormButton
                    formButtonText='Cancel'
                    onClick={() => { handleCancel() }}
                />
                <FormButton
                    formButtonText='Submit'
                    submitButton
                />
            </FormButtonContainer>
        </Form>
    )
}
